import brand from 'brand'
import { __ } from 'lang'
import { Link } from 'react-router-dom'
import AppLogo from './app-logo'
import Breadcrumbs from './breadcrumbs'

export default function WithHeaderLayout({ children, page = 'home' }) {
  const isChicchaching = brand.theme === 'chicchaching'
  if (isChicchaching) {
    const isHome = page === 'home';
    const bannerImageUrl = process.env.REACT_APP_BANNER_IMAGE_URL
    const formCss = {
      position: 'absolute',
      top: '400px',
      backgroundColor: 'white',
      left: '50%',
      transform: 'translateX(-50%)',
      minHeight: '400px',
    }

    if (!isHome) {
      formCss.top = '100px'
    }

    if (page === 'summary') {
      formCss.top = '53px'
    }

    return (
      <div className="flex min-h-screen flex-col">
        <div
          className="my-header-ccc flex w-full items-center justify-center"
          style={{ backgroundColor: 'rgb(124, 0, 0)', height: '52px' }}
        >
          <a href={process.env.REACT_APP_HOME_PAGE_URL} rel="noreferrer noopener" target="_blank">
            <img height={36} src="/returns/images/chicchaching-small-white-logo.png" alt="Logo" className="h-8" />
          </a>
        </div>
        {isHome && (
          <>
            <div className="w-full" style={{ height: '36px' }} />
            <div
              className="ccc-banner w-full bg-cover bg-center mx-auto"
              style={{
                backgroundImage: `url(${bannerImageUrl})`,
                height: '675px',
                maxWidth: '1800px',
              }}
            />
          </>
        )}
        <div className="flex-1">
          <div className="w-full max-w-2xl px-4 py-6 sm:px-6" style={formCss}>
            {children}
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <header className="mx-auto flex w-full max-w-5xl flex-col items-center justify-between py-4 px-6 sm:h-16 sm:flex-row sm:py-0">
        <AppLogo className="mb-6 h-8 w-auto sm:mb-1" />
        <div className="flex items-center space-x-4">
          <Link to="/" className="text-xs uppercase tracking-wider text-gray-700 hover:text-primary-700">
            {__('Search order')}
          </Link>
          <a
            href={process.env.REACT_APP_RETURNS_POLICY_PAGE_URL}
            target="_blank"
            rel="noreferrer noopener"
            className="text-xs uppercase tracking-wider text-gray-700 hover:text-primary-700"
          >
            {__('Returns policy')}
          </a>
          <a
            className="text-xs uppercase tracking-wider text-gray-700 hover:text-primary-700"
            href={process.env.REACT_APP_CONTACT_PAGE_URL}
            rel="noreferrer noopener"
            target="_blank"
          >
            {__('Contact')}
          </a>
          <a
            className="text-xs uppercase tracking-wider text-gray-700 hover:text-primary-700"
            href={process.env.REACT_APP_HOME_PAGE_URL}
            rel="noreferrer noopener"
            target="_blank"
          >
            {__('Shop')}
          </a>
        </div>
      </header>
      <Breadcrumbs className="mt-4">
        <Breadcrumbs.Item>
          <a
            className="text-primary-700 hover:underline"
            href={process.env.REACT_APP_HOME_PAGE_URL}
            rel="noreferrer noopener"
            target="_blank"
          >
            {process.env.REACT_APP_HOME_PAGE_LABEL}
          </a>
        </Breadcrumbs.Item>
        <Breadcrumbs.Item>{__('Returns Portal')}</Breadcrumbs.Item>
      </Breadcrumbs>
      <main className="mx-auto w-full max-w-5xl px-6 py-8">{children}</main>
    </>
  )
}
